export const truncateWithEllipsis = (tag, n) =>
	tag.length > n ? `${tag.slice(0, n - 1)}…` : tag;
